// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawer-content-message #message-selected{padding-top:100px}\n", ""]);
// Exports
module.exports = exports;
